<template>
  <div>
    <vx-card class="relative">
      <div>
        <vs-row vs-w="12" class="mb-5">


          <vs-col vs-lg="4" vs-sm="4" vs-xs="12">
            <vs-button @click="goBack" color="primary" type="border">Back</vs-button>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12">
            <h3>Assign Account Requiring Rebuild - {{ campaignDescription.campaign_name }}</h3>
          </vs-col>

          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12">
            <!-- <h3>{{ campaignDescription.campaign_name }} Accounts</h3> -->
          </vs-col>
        

      

       

          


          <!-- <vs-col vs-lg="1" vs-sm="4" vs-xs="12">
            <vs-button :color="acceptButtonColor" type="filled"
              @click="acceptSelected">{{ accept_text }}</vs-button>


              <input
              type="checkbox"
              v-model="allSelected"
              style="float:right;"
              @click="selectAll"
            />
          </vs-col> -->
        </vs-row>
      </div>
    </vx-card>
    <progress-bar bar-color="grey" :val="uploadPercentage" :text="PLeasewait"></progress-bar>

    <vx-card class="vxtable">

              <div v-if="showDataAdministratorSubmit">
            <div class="vx-row mb-2">
              <div class="vx-col sm:w-1/6 w-full ml-5">
                <h6>Assign To :</h6>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <SalesDeveloperAutocomplete
                  :key="companySDSearchComponentKey"
                  class="searchbox"
                  :list="searchDataAdministrators"
                  :searchOn="'selected_sales_developer'"
                  @event-name="handleSalesDeveloper"
                ></SalesDeveloperAutocomplete>
                <span class="text-danger text-sm">{{
                  please_choose_data_administrator
                }}</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-button @click.prevent="updateDataAdminsIds"
                  >Submit</vs-button
                >
              </div>
            </div>
          </div>


         <ClientDataGrid
              :key="companySDAccountComponentKey"
              @sendSelectionToActualPage="sendSelectionToActualPage"
              ref="AssignAccountRequiringRebuild"
              :columnDefs="accountColumnDefs"
              :rowData="accountRecords"
              :rowSelection="'multiple'"
            >
            </ClientDataGrid>


     
    </vx-card>


  </div>
</template>

<script>
import SalesDeveloperAutocomplete from "@/components/autocomplete/SalesDeveloperAutocomplete.vue";
import ClientDataGrid from "@/components/aggrid/AggridClient.vue";
import moduleAccountsManagement from "@/store/accounts-management/moduleAccountsManagement.js";
import _ from "lodash";
import defineAbilitiesFor from "@/config/abilities";
import axios from "@/axios.js";
import moduleCampaignsManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import moduleElomarkUserManagement from "@/store/elomark-user-management/moduleElomarkUserManagement.js";
import Autocomplete from "@/components/autocomplete/Autocomplete.vue";
import vSelect from "vue-select";
import ProgressBar from 'vue-simple-progress'
 import flatPickr from "vue-flatpickr-component";
    import "flatpickr/dist/flatpickr.css";
    import "quill/dist/quill.core.css";
    import "quill/dist/quill.snow.css";
    import "quill/dist/quill.bubble.css";
export default {
  components: { Autocomplete, "v-select": vSelect , ProgressBar ,             flatPickr , ClientDataGrid,SalesDeveloperAutocomplete
},
  computed: {
    total_pages () {
      console.log("totla" , this.all_total)
      return Math.ceil(this.all_total / this.limit);
    },
    // cloneItems() {
    //     var clone = this.unmatch_accounts;
    //     var startFrom = (this.pagination.page*this.pagination.rowsPerPage)-this.pagination.rowsPerPage;
    //     return clone.splice(startFrom, this.pagination.rowsPerPage);
    // }
  },
  data() {
    return {
      selected_data_administrator_id: null,
            showDataAdministratorSubmit: false,

            please_choose_data_administrator: null,

            companySDSearchComponentKey: 0,

         accountDataSource: [],
      accountRecords: [],
            accountColumnDefs: [],

            companySDAccountComponentKey:0,

                    configDatePicker: {
      enableTime: false,
      dateFormat: 'Y-m-d',
      allowInvalidPreload	: false,
    },
      configDateAndTimePicker: {
      enableTime: true,
      dateFormat: "Y-m-d H:i:s",
      allowInvalidPreload	: false,
      enableSeconds : true
    },
      PLeasewait: '',
      uploadPercentage: 0,
      all_unmatched_accounts : [],
      selected: [],
      allSelected: false,
      all_currency_codes : [],
      all_verticals : [],
      all_sic_codes : [],
      all_countries : [],
      selected_unmatched_account : {}, 
      mandatory_fields: [],
      all_phone_codes:[],
      selected_fields: null,
      phoneTypes: [],
      selected_registered_office_country: null,
      correction_fields_array: [],
      vertical: null,
      selected_vertical: null,
      correction_fields: null,
      selected_registration_jurisdiction: null,
      currencyCodes: [],
      selected_sic_code: null,
      add_or_update_title: null,
      user_id: null,
      user_role: null,
      selected_head_office_country: null,
      abilities: null,
      field_array_columns: [],
      actual_account_name:null,
      registered_office_address_1: null,
      registered_office_address_2: null,
      registered_office_address_3: null,
      registered_office_city: null,
      registered_office_county: null,
      registered_office_postcode: null,
      registered_office_country: null,
      head_office_address_1: null,
      head_office_address_2: null,
      head_office_address_3: null,
      head_office_city: null,
      head_office_county: null,
      head_office_postcode: null,
      company_category: null,
      sic_code: null,
      revenue: null,
      currency_code: null,
      registration_jurisdiction: null,
      no_of_employees: null,
      // sic_code_description: null,
      phone_type: null,
      phone_no: null,
      phone_code: null,
      website: null,
      linkedin: null,
      status: null,
      switchboard: null,
      switchboard_phone_code: null,
      site_switchboard: null,
      site_switchboard_phone_code: null,
      company_name: null,
      selected_fields: null,
      registered_office_country_validation: null,
      EnhancedHeadOfficeAutocompleteComponentKey: 0,
      EnhancedRegOfficeAutocompleteComponentKey: 0,
      EnhancedSicCodeAutocompleteComponentKey: 0,
      EnhancedVerticalAutocompleteComponentKey: 0,
      EnhancedRegistrationJurisdictionAutocompleteComponentKey: 0,
      company_registration_number: null,
      country: null,
      isNewAccount: null,
      update_id: null,
      table: null,
      popupActive: false,
      updateData: [],
      currency_code_validation: null,
      currencyCodes: [],
      abilities: null,
      showHeadOfficeCountryField: true,
      showEditAutocomplete: false,
      telephone_show_no: 5,
      linkedin_show_no: 5,
      website_show_no: 5,
      accountDescription: {},
      accountExists: false,
      websiteExists: false,
      linkedinExists: false,
      parent_name: null,
      RegistrationJurisdiction: null,
      verticalName: null,
      headOfficeIsRegisteredOffice: false,
      old_head_office_address_1: null,
      old_head_office_address_2: null,
      old_head_office_address_3: null,
      old_head_office_city: null,
      old_head_office_county: null,
      old_head_office_postcode: null,
      old_head_office_country: null,
      old_company_registration_number: null,
      accountDescription: {},
      addNewAccountsPopUp: false,
      campaignDescription: [],
      export_link: null,
      abilities: null,
      campaignId: null,
      componentKey: 0,
      limit: 10,
      currentx: 1,
      paginate: { limit: 10, offset: 0 },
      tableData: [],
      header: [],
      sheetName: "",
      list2: [],
      uploaded_columns: [],
      selected_fields: [
        "ml_company",
        "ml_actual_account_name",
        [
          [
            "Head Office Address",
            "Registered Office",
            "State",
            "Town",
            "Country",
            "Postal Code",
            "Site Office"
          ]
        ]
      ],
      unmatch_accounts: [],
      accept_text: "Accept",
      acceptButtonColor: "primary",
      accepted_matches: [],
      combined_matches: [],
      all_total : 0
    };
  },
  mounted() {
    
    this.getCampaignDescription();
      this.getDataRebuildAccountColumns();
      this.getAccountDataSource();
 
  },
  watch: {
   
  },
  methods: {
     goBack: function () {
      this.$router.push('/data_build/campaigns_of_accounts_requiring_rebuild'); 
    },
        getCampaignDescription() {
      const campaignId = this.$route.params.campaignId;
      this.$store
        .dispatch("campaignsManagement/fetchCampaign", campaignId)
        .then(res => {
          this.campaignDescription = res.data;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.campaignDescription = true;
            return;
          }
          console.error(err);
        });
    },
    updateDataAdminsIds() {
      let self = this;
      let data = {};
      data.table_ids = self.selected_table_ids;
      data.data_administrator_id = self.selected_data_administrator_id;
      data.campaign_id = self.campaignId;
      data.assigned_by = self.user_id;
      data.level = "account";

      if (self.selected_data_administrator_id == null) {
        self.please_choose_data_administrator =
          "Please select data manager to update";
      }


      console.log("data.table_ids", data.table_ids);

      self.$vs.loading();





      if (
        self.selected_data_administrator_id != null &&
        self.selected_table_ids.length != 0 &&
        self.campaignId != null
      ) {
        self.$store
          .dispatch("campaignsManagement/assignAccountForRebuild", data)
          .then(res => {
            if (res) {
              if (res.data.status == "success") {
                self.$refs.AssignAccountRequiringRebuild.gridApi.deselectAll();
                 self.$refs.AssignAccountRequiringRebuild.gridApi.refreshCells({force : true});
                self.getAccountDataSource();
                self.$vs.loading.close();

              }
            }
          })
          .catch(err => {
            console.log(err);
          });
      }

      
    },
   getAccountDataSource() {
      var self = this;
      self.$vs.loading();

      let data = {};
      data.campaign_id = self.campaignId;
      self.$store
        .dispatch("accountsManagement/fetchAllDataRebuildAccountsForClientSide", data)
        .then(function(response) {
          let response_data = JSON.parse(response.data);




       



          

          

          self.accountRecords = response_data;


          console.log("account Records" , self.accountRecords)

          self.$vs.loading.close();

        })
        .catch(err => {
          console.error(err);
        });


    },
     getDataRebuildAccountColumns() {
      var self = this;
      self.$store
        .dispatch(
          "campaignsManagement/getAllAccountSelectedCampaignColumnsForRebuild",
          self.campaignId
        )
        .then(res => {
            let selected_columns = JSON.parse(res.data);


                          console.log("selected_columns" , selected_columns)


              selected_columns = selected_columns.filter(function(ele) {
                return ele.identifier == 'Registered Office Country' || ele.identifier == 'Head Office Country'
              });




            selected_columns.forEach(function(ele) {
              ele.headerName = ele.name;
              ele.field = ele.name
              ele.filter = "agTextColumnFilter";

              ele.width = 170;
              ele.filterParams = {
                buttons: ["apply", "reset"],
                maxNumConditions: 4
              };
            });


          self.accountColumnDefs = selected_columns
          let actions = {
            headerCheckboxSelectionFilteredOnly: true,
            headerCheckboxSelection: true,
            headerName: "Actions",
            field: "transactions",
            cellRenderer: "CellRendererActions",
            suppressHeaderMenuButton: true,
            checkboxSelection: true,

            pinned: true,
            width: 50
          };

          this.accountColumnDefs.push(actions);



   let data_assigned_by = {
            field: "assigned_by",
            filter: "agSetColumnFilter",
            filterParams: {
              buttons: ["apply", "reset"],
              maxNumConditions: 4
            },
            headerName: "Allocated By"
          };

          this.accountColumnDefs.push(data_assigned_by);


           let account_status = {
            field: "account_status",
            filter: "agTextColumnFilter",
            filterParams: {
              buttons: ["apply", "reset"],
              maxNumConditions: 4
            },
            headerName: "Account Status"
          };

          this.accountColumnDefs.push(account_status);


                    let account_sub_status = {
            field: "account_sub_status",
            filter: "agTextColumnFilter",
            filterParams: {
              buttons: ["apply", "reset"],
              maxNumConditions: 4
            },
            headerName: "Account Sub Status"
          };

          this.accountColumnDefs.push(account_sub_status);


             let account_status_notes = {
            field: "account_status_notes",
            filter: "agTextColumnFilter",
            filterParams: {
              buttons: ["apply", "reset"],
              maxNumConditions: 4
            },
              cellRenderer: params => {
        var a = document.createElement('div');
        a.textContent = params.data.account_status_notes;
        return a;
      },
            headerName: "Account Status Notes"
          };

          this.accountColumnDefs.push(account_status_notes);



          let data_assigned_on = {
            field: "assigned_on",
            filter: "agDateColumnFilter",
            filterParams: {
              buttons: ["apply", "reset"],
              maxNumConditions: 4,
                     comparator: (filterLocalDateAtMidnight, cellValue) => {
            if (cellValue === null) return -1; // Handle null or empty cell values

            // Convert string cellValue to a Date object
            const cellDate = new Date(cellValue); 

            // Compare the dates
            if (cellDate.getTime() === filterLocalDateAtMidnight.getTime()) {
              return 0;
            }
            if (cellDate < filterLocalDateAtMidnight) {
              return -1;
            }
            if (cellDate > filterLocalDateAtMidnight) {
              return 1;
            }
            return 0; // Fallback
          },
            },
            headerName: "Allocated On"
          };

          this.accountColumnDefs.push(data_assigned_on);


        

          let company_name = {
            field: "company_name",
            filter: "agTextColumnFilter",
            filterParams: {
              buttons: ["apply", "reset"],
              maxNumConditions: 4
            },
            headerName: "Company Name"
          };

          this.accountColumnDefs.push(company_name);


          let rebuild_completed = {
            field: "rebuild_completed",
            filter: "agSetColumnFilter",
            filterParams: {
              buttons: ["apply", "reset"],
              maxNumConditions: 4
            },
            headerName: "Rebuild Completed"
          };

          this.accountColumnDefs.push(rebuild_completed);


          let rebuild_completed_on = {
            field: "rebuild_completed_on",
            filter: "agSetColumnFilter",
            filterParams: {
              buttons: ["apply", "reset"],
              maxNumConditions: 4
            },
            headerName: "Rebuild Completed On"
          };

          this.accountColumnDefs.push(rebuild_completed_on);


          let rebuild_completed_by = {
            field: "rebuild_completed_by",
            filter: "agSetColumnFilter",
            filterParams: {
              buttons: ["apply", "reset"],
              maxNumConditions: 4
            },
            headerName: "Rebuild Completed By"
          };

          this.accountColumnDefs.push(rebuild_completed_by);

          let data_administrator = {
            field: "data_administrator",
            filter: "agSetColumnFilter",
            filterParams: {
              buttons: ["apply", "reset"],
              maxNumConditions: 4
            },
            headerName: "Data Administrator"
          };

          this.accountColumnDefs.push(data_administrator);

          let sorted = _.sortBy(this.accountColumnDefs, function(item) {
            return item.field === "data_administrator" ? 0 : 1;
          });

         

          this.accountColumnDefs = sorted;

        

        })
        .catch(err => {
          console.log(err);
        });
    },
     sendSelectionToActualPage(items) {
      let selected_table_ids = [];

      items.forEach(element => {
        selected_table_ids.push(element.uuid);
      });

      this.selected_table_ids = selected_table_ids;
      this.showDataAdministratorSubmit = true;
    },
    removeDuplicates(myArr, prop) {
      return myArr.filter((obj, pos, arr) => {
        return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
      });
    },
        handleSalesDeveloper() {
      this.selected_data_administrator_id =
        moduleElomarkUserManagement.state.elomark_user.id;
      this.please_choose_data_administrator = null;

      console.log("selected_data_administrator_id" , this.selected_data_administrator_id)
    },
       searchDataAdministrators(inputValue) {
      let data = {};
      data.search = inputValue;
      var self = this;
      return this.$store
        .dispatch("elomarkUsersManagement/getDataAdministrators", data)
        .then(res => {
          let result = res.data;

          console.log("REEEE", result);

          if (result) {
            let mappedArray = [];
            for (const property in result) {
              mappedArray.push({
                id: result[property].uuid,
                name:
                  result[property].first_name +
                  "  -   " +
                  result[property].surname
              });
            }
            return mappedArray;
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function (data) {
      self.abilities = data;
    });
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_id = userInfo["uid"];
    if (!moduleAccountsManagement.isRegistered) {
      this.$store.registerModule(
        "accountsManagement",
        moduleAccountsManagement
      );
      moduleAccountsManagement.isRegistered = true;
    }
        if (!moduleElomarkUserManagement.isRegistered) {
      this.$store.registerModule(
        "elomarkUsersManagement",
        moduleElomarkUserManagement
      );
      moduleElomarkUserManagement.isRegistered = true;
    }
    if (!moduleCampaignsManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignsManagement
      );
      moduleCampaignsManagement.isRegistered = true;
    }
    this.campaignId = this.$route.params.campaignId;
  }
};
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.searchbox {
  padding: 10px 21px;
  width: 600px;
}

.relative {
  /* position: fixed !important; */
  z-index: 999;
  /* width: 98.5%; */
}

.vxtable {
  /* position: absolute !important; */
  margin-top: 20px;
}

.correction_field_class {
  color: red;
}

.correction_field_input_class {
  border: 1px solid red;
}

  .vs-input-class{
        width: 100%;
        border: 1px solid rgba(0, 0, 0, 0.2);
        font-size: 1rem;
        height: 38px;
        padding-left: 10px;
        padding-right: -10px;
        border-radius: 4px;
        background: transparent;
        transition: all .2s ease;
      
      
      }
</style>
